module.exports = __webpack_public_path__ + "img/DuFTabelle1.04261309.png";